import React, { useEffect } from 'react'
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, styled, Typography } from '@mui/material'
import AboutSlick from './headerSlick/AboutSlick';
import headerImage from '../../../assets/images/logo/finalLogo.svg';
import SearchBar from '../../common/searchBar/SearchBar';

const MainBox = styled(Box)(({theme}) => ({
  position: "relative",
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 5,
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
    gap: 0,
  }
}))

const CustomBox = styled(Box)(({theme}) => ({
  width: '60%',
  paddingLeft: theme.spacing(5),
  marginTop: theme.spacing(20),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    width: '90%',
    paddingLeft: theme.spacing(0),
    marginTop: theme.spacing(5),
  }
}))

const SearchBox = styled(Box)(({theme}) => ({
  width: '70%',
  border: '2px solid #242424',
  borderRadius: '5px',
  [theme.breakpoints.down('mdlg')]: {
    width: '80%',
  },
  [theme.breakpoints.down('md')]: {
    width: '95%',
  }
}))

const IconBox = styled(Box)(({theme}) => ({
  width: '25rem',
  height: '25rem',
  [theme.breakpoints.down('xxl')]: {
    width: '20rem',
    height: '20rem',
  },
  [theme.breakpoints.down('lg')]: {
    width: '18rem',
    height: '18rem',
  },
  [theme.breakpoints.down('mdlg')]: {
    width: '15rem',
    height: '15rem',
  },
  [theme.breakpoints.down('md')]: {
    width: '13rem',
    height: '13rem',
  }
}))


function Header() {

  useEffect(() => {
      // Create and append the script
      const script = document.createElement("script");
      script.src = "/finisher-header.es5.min.js"; // adjust path if needed
      script.async = true;
  
      script.onload = () => {
        if (window.FinisherHeader) {
          new window.FinisherHeader({
            count: 4,
            size: {
              min: 1200,
              max: 1500,
              pulse: 0.1,
            },
            speed: {
              x: { min: 0, max: 0.2 },
              y: { min: 0, max: 0.2 },
            },
            colors: {
              background: "#55d6aa",
              particles: ["#349977", "#25f6af", "#a8eed6", "#73ffcf"],
            },
            blending: "lighten",
            opacity: {
              center: 0.8,
              edge: 0.2,
            },
            skew: 0,
            shapes: ["c", "t"],
          });
        }
      };
  
      document.body.appendChild(script);
  
      // Optional cleanup
      // return () => {
      //   document.body.removeChild(script);
      // };
    }, []);

  return (
    <MainBox className="finisher-header" >
      
      {/* <Box sx={{ bgcolor: '#ffdd24', py: 2, ml: -5, borderRadius: '10px'  }} >
        <FormControl sx={{ pl: 4 }} >
          <RadioGroup defaultValue="option1">
            <FormControlLabel value="option1" control={<Radio />} />
            <FormControlLabel value="option2" control={<Radio />} />
            <FormControlLabel value="option3" control={<Radio />} />
          </RadioGroup>
        </FormControl>
      </Box> */}

      <CustomBox>
        <Box sx={{ width: { xs: '90%', md: '100%' }, mt: { xs: 2, md: 8 } }} >
          <AboutSlick/>
        </Box>
        
        <Box sx={{ width: '100%', mt: { xs: 2, md: 7 }, mb: 4, display: 'flex', justifyContent: { xs: 'center', md: 'start' }, alignItems: 'center', zIndex: 1 }} >
          <SearchBox>
            <SearchBar width='100%' height='2.5rem' />
          </SearchBox>
        </Box>
      </CustomBox>
      
      <IconBox component="img" src={headerImage} sx={{ width: '25%', height: '25%' }} />

    </MainBox>
  )
}

export default Header
